<template lang="pug">
  .pRow
    .pRow__chatBody.d-inline-block.position-relative
      .chatBody__outSideBox
        .row.flex-row-reverse.no-gutters.align-items-start.flex-nowrap
          .pRow__profileImg.ml-3.d-none(
            v-if="this.profile_picture",
            @click="showLightBox(profile_picture)"
          )
            ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
              :profileUrl="this.profile_picture",
              :style="{ 'width': '50px', 'height': '50px' }"
            )
          .d-flex.align-items-end.flex-nowrap.flex-row-reverse.no-gutters
            .pRow__content.pRow__imgBox.position-relative.d-flex.align-items-center
              .imgBox__insideImgBox
                img(
                  v-lazy="require(`@/assets/images/lineStickers/${this.messageData.package_id}/${this.messageData.sticker_id}.png`)",
                  v-if="hasSticker"
                )
                img(
                  v-lazy="defaultStickerImg",
                  v-else
                )
            .pRow__timeBox
              span.text-right(
                v-if="this.messageData.is_read"
              ) 已讀
              span.cursor-default.text-right {{ filterToday(this.messageData.time) }}
</template>

<script>
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import defaultPreviewImgUrl from '@/assets/images/default/defaultImg404.png';
import defaultStickerImgUrl from '@/assets/images/lineStickers/unupload.png';

import packageIdArray from '@/helper/LineStickers/package/packageId.json';
import stickerIdArray from '@/helper/LineStickers/package/stickerId.json';

export default {
  name: 'P-Sticker',
  components: {
    ProfilePhotoSticker
  },
  props: {
    messageData: {
      type: Object,
      required: true
    },
    profile_picture: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      defaultPreviewImg: `this.src="${defaultPreviewImgUrl}"`,
      defaultStickerImg: defaultStickerImgUrl,
      packageIdArray,
      stickerIdArray,
      hasSticker: false
    };
  },
  mounted() {
    const vm = this;
    // 判斷是否有這個貼圖
    if (vm.packageIdArray.indexOf(parseInt(vm.messageData.package_id)) !== -1 && vm.stickerIdArray.indexOf(parseInt(vm.messageData.sticker_id)) !== -1) {
      vm.hasSticker = true;
    }
  },
  methods: {
    // 通知父組件顯示幻燈片
    showLightBox(imageUrl) {
      this.$emit('showLightBox', imageUrl);
    }
  }
};
</script>

<style>

</style>
